module.exports = __webpack_public_path__ + "img/975aeb5.png";